import {
  getRequiredFields,
  removeEmptyFields,
  setEmptyFieldsToNull,
} from "@/lib/utils";
import { NEWS } from "./consts";
import { zodResolver } from "@hookform/resolvers/zod";
import { formValues, schema } from "./validations";
import { useForm } from "react-hook-form";
import { useAddLatestNewsMutation, useGetLatestNews } from "@/services";
import { toast } from "sonner";
import { useEffect } from "react";

const useLatestNews = (selectedTab?: string) => {
  const form = useForm<formValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      [NEWS]: "",
    },
  });

  const requiredFields = getRequiredFields(schema);

  const { data: latestNews, isLoading: isLoadingLatestNews } = useGetLatestNews({
    applicableCompany: selectedTab?.toUpperCase(),
  });


  useEffect(() => {
    if (latestNews) {
      form.reset({ [NEWS]: latestNews?.data?.news || "" });
    }
  }, [latestNews]);

  const { mutate: addInfo, isPending: isAddPending } = useAddLatestNewsMutation(
    {
      onError: (error?: any) => {
        toast.error(
          typeof error?.response?.data?.issues?.error === "string"
            ? error?.response?.data?.issues?.error
            : typeof error?.response?.data?.message === "string"
            ? error?.response?.data?.message
            : "Something went wrong",
          {
            className: "!bg-red-500 !text-white",
          }
        );
        return error?.response?.data?.message;
      },
      onSuccess: () => {
        toast.success("Latest News Updated Successfully", {
          className: "!bg-green-600 !text-white",
        });
      },
    }
  );

  const onSubmit = (data: any) => {
    let _data = removeEmptyFields(data);
    _data = setEmptyFieldsToNull(_data);

    addInfo({
      data: { 
        ..._data,
        applicableCompany: selectedTab?.toUpperCase(),
      },
    });
  };

  return {
    form,
    requiredFields,
    onSubmit,
    isLoadingLatestNews,
    isAddPending,
  };
};

export default useLatestNews;
